/*
  表单验证失败时的错误文字
 */
export default {
  // 错误信息
  errorMsgs () {
    let errorMsgs = {
      // 名字
      lastname: {
        required: '请填写您的英文/姓名拼音',
        onlyEnglish: '名字必须为英文字母',
      },
      // 姓氏
      name: {
        required: '请填写您的姓氏',
        onlyEnglish: '姓氏必须为英文字母',
      },
      // 真实姓名
      realName: {
        required: '请填写您的真实姓名',
      },
      // 昵称
      nickName: {
        required: '昵称不能为空',
      },
      // 性别
      sex: {
        required: '请选择您的性别',
      },
      // 证件类型
      identityType: {
        required: '请选择您的证件类别',
      },
      // 证件号码
      identityNo: {
        required: '请填写您的证件号码',
      },

      // 原高级认证
      countryCode: { required: '请选择居住地址' }, // 国籍
      province: { // 省
        required: '省/市/自治区不能为空',
        numberAndWordAndSymbol: '省/市/自治区只能输入英文字母、数字或英文特殊符号的组合',
      },
      city: { // 市
        required: '城市/乡镇不能为空',
        numberAndWordAndSymbol: '城市/乡镇只能输入英文字母、数字或英文特殊符号的组合',
      },
      district: { // 区
        required: '区不能为空',
        numberAndWordAndSymbol: '区只能输入英文字母、数字或英文特殊符号的组合',
      },
      buildingNumber: { // 建筑门牌号
        required: '建筑名称/门牌号不能为空',
        numberAndWordAndSymbol: '建筑名称/门牌号只能输入英文字母、数字或英文特殊符号的组合',
      },
      street: { // 街道
        required: '街道名不能为空',
        numberAndWordAndSymbol: '街道名只能输入英文字母、数字或英文特殊符号的组合',
      },
      apartmentNumber: { // 公寓号
        required: '公寓号不能为空',
        numberAndWordAndSymbol: '公寓号只能输入英文字母、数字或英文特殊符号的组合',
      },
      zipCode: { // 邮政编码
        required: '邮政编码不能为空',
        numberAndWord: '邮政编码只能输入英文字母、数字或两者组合',
      },

      employmentStatus: { // 就业状态
        required: '请选择就业状况',
      },
      industry: { // 行业
        required: '请选择行业',
      },
      jobTitle: { // 职位名称
        required: '职位名称/描述不能为空',
      },
      companyName: { // 雇主/公司名称
        required: '雇主名称不能为空',
      },
      employerCountryCode: { // 雇主国籍
        required: '请选择雇主国家/地区',
      },
      employerProvince: { // 雇主省
        required: '雇主州/省不能为空',
        numberAndWordAndSymbol: '雇主州/省必须是英文字母、数字或英文特殊符号的组合',
      },
      employerCity: { // 雇主市
        required: '雇主城市或镇不能为空',
        numberAndWordAndSymbol: '雇主城市或镇必须是英文字母、数字或英文特殊符号的组合',
      },
      employerDistrict: { // 雇主区
        required: '雇主区不能为空',
        numberAndWordAndSymbol: '雇主区必须是英文字母、数字或英文特殊符号的组合',
      },
      employerBuildingNumber: { // 雇主建筑门牌号
        required: '雇主建筑物名称/房屋号码不能为空',
        numberAndWordAndSymbol: '雇主建筑物名称/房屋号码必须是英文字母、数字或英文特殊符号的组合',
      },
      employerStreet: { // 雇主街道
        required: '雇主街道名称不能为空',
        numberAndWordAndSymbol: '雇主街道名称必须是英文字母、数字或英文特殊符号的组合',
      },
      employerZipCode: { // 雇主邮政编码
        required: '雇主邮编/邮政编码不能为空',
        numberAndWordAndSymbol: '雇主邮编/邮政编码只能输入英文字母、数字或两者组合',
      },
      sourceIncome: { // 收入来源
        required: '请选择资金来源',
      },
      grossAsset: { // 净资产价值美元
        required: '请选择净资产',
      },
      expectedInvestment: { // 预期投资水平
        required: '请选择预期投资水平',
      },
      hasInvestedStockMarket: { // 是否投资过股市
        required: '请选择是否投资过股市',
      },
      stockMarketInvestment: { // 股市投资年限
        required: '股票投资经验不能为空',
        yearNumbers: '股票投资经验 (年数)必须为数字',
      },
      derivativeInvestment: { // 衍生品市场投资年限
        required: '衍生品市场投资经验不能为空',
        yearNumbers: '衍生品市场投资经验 (年数)必须为数字',
      },
      understandBlockchanAssetTrade: { // 是否了解风险交易区块链资产
        required: '请选择是否了解风险交易区块链资产',
      },
      understandDerivativeMarket: { // 是否了解验证品市场如何运作
        required: '请选择是否了解验证品市场如何运作',
      },
    };
    return errorMsgs;
  },
  // 生日
  birthday_errorMsg () {
    let $form = this.$v.form;
    let yearError = $form.year.$error && !$form.year.required;
    let monthError = $form.month.$error && !$form.month.required;
    let dayError = $form.day.$error && !$form.day.required;
    let birthdayError = $form.birthday.$error && !$form.birthday.age18;
    let msg1 = '请选择您的生日日期';
    let msg2 = '年龄必须大于18岁';
    if (yearError || monthError || dayError) {
      return msg1;
    }
    if (birthdayError) {
      return msg2;
    }
    return '';
  },
  // 国籍
  /* countryCode_errorMsg(){
    let $countryCode = this.$v.form.countryCode;
    if($countryCode.$error){
      if(!$countryCode.required){
        return '请选择您的国籍';
      }
    }else{
      return ' ';
    }
  } */
};
